import React from 'react';
import { SurveyPage } from './pages/SurveyPage';
export function App() {
  return <SurveyPage data-id="element-0" />;
}